import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroBanner } from '../components/HeroBanner';
import { ProductShowcase } from '../components/ProductShowcase';
import { DailyEssentials } from '../components/DailyEssentials';
import { TechnologySection } from '../components/TechnologySection';
import { HumanSection } from '../components/HumanSection';
import { StoriesSection } from '../components/StoriesSection';
import { FeaturedSection } from '../components/FeaturedSection';
import { Footer } from '../components/Footer';
export const Home = () => {
  return <div className="min-h-screen bg-white" data-id="element-308">
      <Navbar data-id="element-309" />
      <main className="scroll-smooth" data-id="element-310">
        <HeroBanner data-id="element-311" />
        <ProductShowcase data-id="element-312" />
        <DailyEssentials data-id="element-313" />
        <TechnologySection data-id="element-314" />
        <HumanSection data-id="element-315" />
        <StoriesSection data-id="element-316" />
        <FeaturedSection data-id="element-317" />
      </main>
      <Footer data-id="element-318" />
    </div>;
};